import * as React from 'react';
type Props = {
    space?: number;
};
export default ({space = 10}: Props) => (
    <div style={{height: space}}/>
);
